var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 100 100",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CACAD5",
    d: "M45.429 18.35c2.142-3.71 7.5-3.71 9.642 0l30.411 52.674c2.143 3.712-.535 8.351-4.82 8.351H19.838c-4.286 0-6.964-4.64-4.821-8.35z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B9BAB",
    d: "M47.283 25.306c1.319-2.284 4.615-2.284 5.934 0l25.314 43.846c1.32 2.284-.33 5.139-2.967 5.139H24.936c-2.638 0-4.286-2.855-2.967-5.139z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M52.854 66.914a2.604 2.604 0 1 1-5.208 0 2.604 2.604 0 0 1 5.208 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M50.126 34.89c1.183 0 2.141.958 2.141 2.14v21.08a2.141 2.141 0 0 1-4.282 0V37.03c0-1.182.958-2.14 2.141-2.14",
    clipRule: "evenodd"
  })));
});
const SvgWarning = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik00NS40Mjg3IDE4LjM1MDdDNDcuNTcxNSAxNC42MzkzIDUyLjkyODUgMTQuNjM5MyA1NS4wNzEzIDE4LjM1MDdMODUuNDgyNCA3MS4wMjQzQzg3LjYyNTIgNzQuNzM1NyA4NC45NDY3IDc5LjM3NSA4MC42NjExIDc5LjM3NUgxOS44Mzg5QzE1LjU1MzMgNzkuMzc1IDEyLjg3NDggNzQuNzM1NyAxNS4wMTc2IDcxLjAyNDNMNDUuNDI4NyAxOC4zNTA3WiIgZmlsbD0iI0NBQ0FENSIvPgo8cGF0aCBkPSJNNDcuMjgzMSAyNS4zMDYzQzQ4LjYwMTcgMjMuMDIyMyA1MS44OTgzIDIzLjAyMjMgNTMuMjE3IDI1LjMwNjNMNzguNTMxNCA2OS4xNTIxQzc5Ljg1MDEgNzEuNDM2MSA3OC4yMDE4IDc0LjI5MSA3NS41NjQ1IDc0LjI5MUgyNC45MzU2QzIyLjI5ODMgNzQuMjkxIDIwLjY1IDcxLjQzNjEgMjEuOTY4NyA2OS4xNTIxTDQ3LjI4MzEgMjUuMzA2M1oiIGZpbGw9IiM5QjlCQUIiLz4KPHBhdGggZD0iTTUyLjg1NCA2Ni45MTM1QzUyLjg1NCA2OC4zNTE1IDUxLjY4ODIgNjkuNTE3MyA1MC4yNTAxIDY5LjUxNzNDNDguODEyIDY5LjUxNzMgNDcuNjQ2MiA2OC4zNTE1IDQ3LjY0NjIgNjYuOTEzNUM0Ny42NDYyIDY1LjQ3NTQgNDguODEyIDY0LjMwOTYgNTAuMjUwMSA2NC4zMDk2QzUxLjY4ODIgNjQuMzA5NiA1Mi44NTQgNjUuNDc1NCA1Mi44NTQgNjYuOTEzNVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNTAuMTI2IDM0Ljg4OTdDNTEuMzA4NSAzNC44ODk3IDUyLjI2NzIgMzUuODQ4MyA1Mi4yNjcyIDM3LjAzMDlMNTIuMjY3MiA1OC4xMUM1Mi4yNjcyIDU5LjI5MjUgNTEuMzA4NSA2MC4yNTEyIDUwLjEyNiA2MC4yNTEyQzQ4Ljk0MzQgNjAuMjUxMiA0Ny45ODQ4IDU5LjI5MjUgNDcuOTg0OCA1OC4xMUw0Ny45ODQ4IDM3LjAzMDlDNDcuOTg0OCAzNS44NDgzIDQ4Ljk0MzQgMzQuODg5NyA1MC4xMjYgMzQuODg5N1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";